/**
 * DynamicEventCalculator
 * Calculates how many events fit in calendar day cells.
 */

import { Dimensions } from 'react-native';

type EventDisplayInfo = {
  eventsToShow: number;
  showOverflow: boolean;
  overflowCount: number;
};

export class DynamicEventCalculator {
  private static readonly EVENT_BAR_HEIGHT = 12;
  private static readonly EVENT_GAP = 1;
  private static readonly DAY_NUMBER_AREA_HEIGHT = 15;
  private static readonly CELL_VERTICAL_PADDING = 4;
  private static readonly EVENTS_CONTAINER_PADDING_TOP = 1;
  private static readonly SCREEN_HEIGHT = Dimensions.get('window').height;

  private static getScreenHeightMaxSlots(): number {
    if (this.SCREEN_HEIGHT < 700) return 2;
    if (this.SCREEN_HEIGHT < 800) return 3;
    return 4;
  }

  static calculateMaxSlots(cellHeight: number): number {
    const availableHeight = cellHeight
      - this.DAY_NUMBER_AREA_HEIGHT
      - this.CELL_VERTICAL_PADDING
      - this.EVENTS_CONTAINER_PADDING_TOP;
    const slotHeight = this.EVENT_BAR_HEIGHT + this.EVENT_GAP;
    const fitSlots = Math.max(1, Math.floor(availableHeight / slotHeight));
    const screenCap = this.getScreenHeightMaxSlots();
    return Math.min(fitSlots, screenCap);
  }

  static calculateEventDisplay(totalEvents: number, maxSlots: number): EventDisplayInfo {
    if (totalEvents <= maxSlots) {
      return { eventsToShow: totalEvents, showOverflow: false, overflowCount: 0 };
    }
    const eventsToShow = maxSlots - 1;
    return { eventsToShow, showOverflow: true, overflowCount: totalEvents - eventsToShow };
  }
}
